import { render } from "./IconUser.vue?vue&type=template&id=42d5bb96&scoped=true"
import script from "./IconUser.vue?vue&type=script&lang=js"
export * from "./IconUser.vue?vue&type=script&lang=js"

import "./IconUser.vue?vue&type=style&index=0&id=42d5bb96&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d5bb96"]])

export default __exports__